export default {
    ERRO_PROCESSAMENTO: 'Erro Processamento',
    FINALIZADO: 'Finalizado'
  }
